import { Link } from 'react-router-dom';
import type { ComicData } from '@/mocks/comics';

interface ComicCardProps {
  comic: ComicData;
  size?: 'small' | 'medium' | 'large';
}

export default function ComicCard({ comic, size = 'medium' }: ComicCardProps) {
  const coverSizes = {
    small: 'w-[140px] h-[190px] md:w-[160px] md:h-[216px]',
    medium: 'w-[160px] h-[216px] md:w-[180px] md:h-[243px]',
    large: 'w-[180px] h-[243px] md:w-[200px] md:h-[270px]',
  };

  const titleSizes = {
    small: 'text-sm',
    medium: 'text-sm md:text-base',
    large: 'text-base md:text-lg',
  };

  return (
    <Link
      to={`/article/${comic.id}`}
      className="group block cursor-pointer"
    >
      <div className={`relative ${coverSizes[size]} rounded-lg overflow-hidden bg-background-200`}>
        <img
          src={comic.cover}
          alt={comic.title}
          title={`${comic.title} - 免费在线漫画阅读`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
          <span className="text-white text-xs font-medium whitespace-nowrap">点击阅读</span>
        </div>
        {comic.status === '连载中' && (
          <span className="absolute top-2 left-2 px-2 py-0.5 text-[10px] font-medium bg-primary-500 text-white rounded-full whitespace-nowrap">
            连载
          </span>
        )}
        {comic.status === '已完结' && (
          <span className="absolute top-2 left-2 px-2 py-0.5 text-[10px] font-medium bg-accent-500 text-white rounded-full whitespace-nowrap">
            完结
          </span>
        )}
        <div className="absolute top-2 right-2 px-2 py-0.5 text-[10px] font-medium bg-black/50 text-white rounded-full whitespace-nowrap">
          {comic.rating}
        </div>
      </div>
      <div className="mt-2.5">
        <h3 className={`${titleSizes[size]} font-semibold text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1 whitespace-nowrap`}>
          {comic.title}
        </h3>
        <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
        {size !== 'small' && (
          <div className="flex items-center gap-2 mt-1.5 flex-wrap">
            {comic.tags.slice(0, 2).map((tag) => (
              <span
                key={tag}
                className="px-2 py-0.5 text-[10px] bg-secondary-100 text-secondary-700 rounded-full whitespace-nowrap"
              >
                {tag}
              </span>
            ))}
          </div>
        )}
      </div>
    </Link>
  );
}